import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Dropdown, Button} from 'semantic-ui-react';
import {startsWith} from '../../../common/util/dropdown';
import {hideNewLocationsModal} from '../../actions/locationsAssignment';
import {parseFreeLocations} from '../../utils';
import './locationSearch.scss';

class NewLocationSearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'locationSelected': '',
    };
  }

  updateLocation(value) {
    this.setState({'locationSelected': value});
  }

  onCloseModalClick() {
    this.props.hideNewLocationsModal();
  }
  
  onAcceptClick() {
    const {locationSelected} = this.state;
    this.props.handleFieldChange(
      this.props.index, null, {'name': 'newLocation', 'value': locationSelected});
    this.onCloseModalClick();
  }


  render() {
    const {locationSelected} = this.state;
    const {open, freeLocations} = this.props;
    if (!open) {
      return null;
    }
    
    return (
      <Modal size='tiny'
        className='locations-search'
        open
      >
        <Modal.Header>
          Ubicación Nueva
        </Modal.Header>
        
        <Modal.Content>
          <Modal.Description>
            <Dropdown
              selection
              search={startsWith}
              options={parseFreeLocations(freeLocations) || []}
              onChange={(e, {value}) => this.updateLocation(value)}
              placeholder='Seleccione una ubicación'
              noResultsMessage='No existe la ubicación seleccionada' />
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={() => this.onCloseModalClick()}>
            Cancelar
          </Button>
          <Button positive
            disabled={!locationSelected}
            onClick={() => this.onAcceptClick()}>
            Aceptar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  'hideNewLocationsModal': hideNewLocationsModal,
};

const mapStateToProps = (state) => {
  return {
    'index': state.locationsAssignment.selectedIndex,
    'open': state.locationsAssignment.newLocationModal,
    'freeLocations': state.locationsAssignment.freeLocations,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewLocationSearchModal);
